import { MaterialDesignContent } from 'notistack';
// @mui
import { styled, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledNotistack = styled(MaterialDesignContent)(({ theme }) => {
  const isLight = theme.palette.mode === 'light';
  const variantSurface = (color: 'info' | 'success' | 'warning' | 'error') => ({
    color: theme.palette[color][isLight ? 'darker' : 'lighter'],
    background: `linear-gradient(135deg, ${alpha(theme.palette[color].main, isLight ? 0.14 : 0.2)} 0%, ${theme.palette.background.paper} 100%)`,
    border: `1px solid ${alpha(theme.palette[color].main, 0.22)}`,
  });

  return {
    '& #notistack-snackbar': {
      ...theme.typography.body2,
      padding: 0,
      flexGrow: 1,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&.notistack-MuiContent': {
      padding: theme.spacing(0.75),
      paddingRight: theme.spacing(2),
      color: theme.palette.text.primary,
      boxShadow: theme.customShadows.z8,
      borderRadius: Number(theme.shape.borderRadius) * 1.5,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
    },
    '&.notistack-MuiContent-default': {
      padding: theme.spacing(1),
      color: isLight ? theme.palette.common.white : theme.palette.grey[800],
      backgroundColor: isLight ? theme.palette.grey[800] : theme.palette.common.white,
    },
    '&.notistack-MuiContent-info': variantSurface('info'),
    '&.notistack-MuiContent-success': variantSurface('success'),
    '&.notistack-MuiContent-warning': variantSurface('warning'),
    '&.notistack-MuiContent-error': variantSurface('error'),
  };
});

// ----------------------------------------------------------------------

type StyledIconProps = {
  color: 'info' | 'success' | 'warning' | 'error';
};

export const StyledIcon = styled('span')<StyledIconProps>(({ color, theme }) => ({
  width: 44,
  height: 44,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(1.5),
  color: theme.palette[color].main,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette[color].main, 0.16),
}));
